// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2RavN","header":"PatientBlock_header__3_90H","label":"PatientBlock_label__n_m-J","option":"PatientBlock_option__1aN1x"};